module.exports = __webpack_public_path__ + "static/media/p1_token.9750cb3c.png";